import AxiosService from './axios.service';
import { AxiosResponse } from 'axios';
import { CreatePaginaDto, Pagina, UpdatePaginaDto } from './types/cursos.types';

export class PaginasService {
  static async create(moduloId: string, dto: CreatePaginaDto): Promise<Pagina> {
    const response: AxiosResponse<Pagina> = await AxiosService.post(`/cursos/modulos/${moduloId}/paginas`, dto);
    return response.data;
  }

  static async findAllByModulo(moduloId: string): Promise<Pagina[]> {
    const response: AxiosResponse<Pagina[]> = await AxiosService.get(`/cursos/modulos/${moduloId}/paginas`);
    return response.data;
  }

  static async findOne(id: string): Promise<Pagina> {
    const response: AxiosResponse<Pagina> = await AxiosService.get(`/cursos/paginas/${id}`);
    return response.data;
  }

  static async findOneForRender(id: string): Promise<Pagina> {
    const response: AxiosResponse<Pagina> = await AxiosService.get(`/cursos/paginas/${id}/render`);
    return response.data;
  }

  static async update(id: string, dto: UpdatePaginaDto): Promise<Pagina> {
    const response: AxiosResponse<Pagina> = await AxiosService.patch(`/cursos/paginas/${id}`, dto);
    return response.data;
  }

  static async remove(id: string): Promise<void> {
    await AxiosService.delete(`/cursos/paginas/${id}`);
  }
}
